class SideCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.sidecart');
    this.panel = this.querySelector('.sidecart__panel');
    this.overlay = this.querySelector('.sidecart__overlay');
    this.closeBtns = this.querySelectorAll('[data-sidecart-close]');
    this.openers = document.querySelectorAll('[data-sidecart-open]');
    this.onKeydown = this.onKeydown.bind(this);
    this.onTransEnd = this.onTransEnd.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCartUpdated = this.onCartUpdated.bind(this);
    this.lastActive = null;
  }
  connectedCallback() {
    this.openers.forEach(btn => btn.addEventListener('click', () => this.open()));
    this.closeBtns.forEach(btn => btn.addEventListener('click', () => this.close()));
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    if (this.panel) this.panel.addEventListener('transitionend', this.onTransEnd);
    this.addEventListener('click', this.onClick);
    this.addEventListener('change', this.onChange);
    document.addEventListener('cart:updated', this.onCartUpdated);
    this.querySelectorAll('.plan-btn[aria-current="true"]').forEach(b=>b.classList.add('active'));
    this.initSlider();
    this.seedActiveFromAria();
    this.hideSubIfNoPlans();
  }
  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdated);
  }
  async reloadSidecart() {
    const hostSection = this.closest('[data-section-id]');
    const sectionId = hostSection?.dataset.sectionId;
    if (!sectionId) return false;
    const u = new URL(window.location.href);
    u.searchParams.set('sections', sectionId);
    const r = await fetch(u.toString(), { headers: { 'X-Requested-With':'XMLHttpRequest' }, cache: 'no-store' });
    if (!r.ok) return false;
    const json = await r.json();
    const html = json[sectionId];
    if (!html) return false;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    const newBody = tmp.querySelector('#SideCartContent');
    const newBadge = tmp.querySelector('.header__cart-badge');
    const curBody = this.querySelector('#SideCartContent');
    const curBadge = this.querySelector('.header__cart-badge');

    if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
    if (newBadge && curBadge) curBadge.textContent = newBadge.textContent;

    this.initSlider();
    this.seedActiveFromAria();
    this.hideSubIfNoPlans();
    calcShipping();

    return true;
  }
  async onCartUpdated(e) {
    const detail = (e && e.detail) || {};
    const vId = detail.variantId ? String(detail.variantId) : null;
    const planId = detail.planId || detail.sellingPlan || null;
    await this.reloadSidecart();
    this.open();
    if (vId && planId) {
      this.selectActiveFor(vId, String(planId));
    } else if (vId && !planId) {
      const itemEl = this.querySelector(`.cart-card__item[data-id="${vId}"]`);
      if (itemEl) {
        const chk = itemEl.querySelector('.switcher-upsell input');
        const wrap = itemEl.querySelector('[data-plan-wrap]');
        const unchecked = itemEl.querySelector('.cart-card__item-unchecked');
        if (chk) chk.checked = false;
        if (wrap) wrap.classList.add('is-hidden');
        if (unchecked) unchecked.classList.remove('is-hidden');
      }
    }
  }
  async updateSellingPlan(key, planId) {
    const itemEl = this.querySelector(`.cart-card__item [data-key="${key}"]`)?.closest('.cart-card__item') || this.querySelector(`.cart-card__item[data-key="${key}"]`);
    const variantId = itemEl ? itemEl.getAttribute('data-id') : null;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, selling_plan: planId })
    });
    await this.enforceGiftRules();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { variantId: variantId ? Number(variantId) : null, planId: planId || null } }));
  }
  async changeQuantity(key, quantity) {
    const itemEl = this.querySelector(`.cart-card__item [data-key="${key}"]`)?.closest('.cart-card__item') || this.querySelector(`.cart-card__item[data-key="${key}"]`);
    const variantId = itemEl ? itemEl.getAttribute('data-id') : null;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await this.enforceGiftRules();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { variantId: variantId ? Number(variantId) : null } }));
  }
  isGift(itemEl) {
    return itemEl && itemEl.dataset.gift === 'true';
  }
  showEl(el) {
    if (!el) return;
    el.classList.remove('is-hidden');
    el.classList.remove('is-hiding');
    void el.offsetWidth;
  }
  hideEl(el) {
    if (!el) return;
    el.classList.add('is-hiding');
    const onEnd = () => {
      el.classList.add('is-hidden');
      el.classList.remove('is-hiding');
      el.removeEventListener('animationend', onEnd);
      el.removeEventListener('transitionend', onEnd);
    };
    el.addEventListener('animationend', onEnd, { once: true });
    el.addEventListener('transitionend', onEnd, { once: true });
  }
  onChange(e) {
    if (!e.target.matches('.switcher-upsell input')) return;
    const item = e.target.closest('.cart-card__item');
    if (!item) return;
    if (this.isGift(item)) return;
    const key = item.querySelector('[data-key]')?.dataset.key || item.dataset.key || '';
    if (!key) return;
    const group = item.querySelector('[data-plan-wrap]');
    const unchecked = item.querySelector('.cart-card__item-unchecked');
    if (e.target.checked) {
      this.hideEl(unchecked);
      this.showEl(group);
      const btn = group?.querySelector('[data-plan-btn][aria-current="true"]') || group?.querySelector('[data-plan-btn]');
      if (!btn) return;
      const g = btn.closest('.plan-buttons');
      if (g) g.querySelectorAll('.plan-btn').forEach(b => { b.classList.remove('active'); b.removeAttribute('aria-current'); });
      btn.classList.add('active');
      btn.setAttribute('aria-current','true');
      this.updateSellingPlan(key, Number(btn.dataset.planId));
    } else {
      this.hideEl(group);
      this.showEl(unchecked);
      this.updateSellingPlan(key, null);
    }
  }
  onClick(e) {
    const planBtn = e.target.closest('[data-plan-btn]');
    if (planBtn) {
      const itemEl = planBtn.closest('.cart-card__item');
      if (this.isGift(itemEl)) return;
      const group = planBtn.closest('.plan-buttons');
      if (group) group.querySelectorAll('.plan-btn').forEach(b=>{ b.classList.remove('active'); b.removeAttribute('aria-current'); });
      planBtn.classList.add('active');
      planBtn.setAttribute('aria-current','true');
      const key = planBtn.dataset.key || planBtn.getAttribute('data-key');
      const wrap = planBtn.closest('[data-plan-wrap]');
      const dsKey = wrap ? wrap.getAttribute('data-key') : null;
      const finalKey = key || dsKey || itemEl?.dataset.key || itemEl?.querySelector('[data-key]')?.dataset.key || '';
      this.updateSellingPlan(finalKey, Number(planBtn.dataset.planId));
      return;
    }
    const toggle = e.target.closest('[data-sub-toggle]');
    if (toggle) {
      const itemEl = toggle.closest('.cart-card__item');
      if (this.isGift(itemEl)) return;
      const key = toggle.dataset.key;
      const pressed = toggle.getAttribute('aria-pressed') === 'true';
      if (pressed) {
        this.updateSellingPlan(key, null);
      } else {
        const wrap = this.querySelector(`[data-plan-wrap][data-key="${key}"]`);
        const firstBtn = wrap?.querySelector('[data-plan-btn]');
        if (firstBtn) {
          const group = firstBtn.closest('.plan-buttons');
          if (group) group.querySelectorAll('.plan-btn').forEach(b=>{ b.classList.remove('active'); b.removeAttribute('aria-current'); });
          firstBtn.classList.add('active');
          firstBtn.setAttribute('aria-current','true');
          this.updateSellingPlan(key, Number(firstBtn.dataset.planId));
        }
      }
      return;
    }
    const qtyBtn = e.target.closest('.qty-btn');
    if (qtyBtn) {
      const itemEl = qtyBtn.closest('.cart-card__item');
      if (this.isGift(itemEl)) return;
      const wrap = qtyBtn.closest('.cart-card__quantity');
      if (!wrap) return;
      const key = wrap.dataset.key;
      const valEl = wrap.querySelector('.qty-value');
      const current = Number((valEl?.textContent || '1').trim());
      const delta = qtyBtn.dataset.action === 'inc' ? 1 : -1;
      const next = Math.max(0, current + delta);
      this.changeQuantity(key, next);
      return;
    }
  }
  open() {
    if (!this.container) return;
    this.lastActive = document.activeElement;
    this.container.classList.add('is-visible');
    requestAnimationFrame(() => this.container.classList.add('is-open'));
    this.container.setAttribute('aria-hidden', 'false');
    document.body.classList.add('body--sidecart-open');
    document.addEventListener('keydown', this.onKeydown);
  }
  close() {
    if (!this.container) return;
    this.container.classList.remove('is-open');
    this.container.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('body--sidecart-open');
    document.removeEventListener('keydown', this.onKeydown);
    this.lastActive?.focus?.();
  }
  onTransEnd(e) {
    if (e.target !== this.panel || e.propertyName !== 'transform') return;
    if (!this.container.classList.contains('is-open')) {
      this.container.classList.remove('is-visible');
    }
  }
  seedActiveFromAria() {
    this.querySelectorAll('.plan-buttons').forEach(group => {
      const current = group.querySelector('.plan-btn[aria-current="true"]');
      if (current && !current.classList.contains('active')) {
        group.querySelectorAll('.plan-btn').forEach(b => b.classList.remove('active'));
        current.classList.add('active');
      }
    });
  }
  hideSubIfNoPlans() {
    this.querySelectorAll('.cart-card__item').forEach(item => {
      const attr = item.getAttribute('data-has-selling-plans');
      let hasPlans = null;
      if (attr !== null) hasPlans = attr === 'true';
      if (hasPlans === null) hasPlans = item.querySelectorAll('[data-plan-btn]').length > 0;
      const sub = item.querySelector('.cart-card__sub');
      const switcher = item.querySelector('.switcher-upsell');
      if (sub && !hasPlans) sub.classList.add('is-hidden');
      if (switcher && !hasPlans) switcher.classList.add('is-hidden');
    });
  }
  selectActiveFor(variantId, planId) {
    const itemEl = this.querySelector(`.cart-card__item[data-id="${variantId}"]`);
    if (!itemEl) return false;
    const group = itemEl.querySelector('.plan-buttons');
    if (!group) return false;
    group.querySelectorAll('.plan-btn').forEach(b => {
      const is = String(b.dataset.planId) === String(planId);
      b.classList.toggle('active', is);
      if (is) b.setAttribute('aria-current','true'); else b.removeAttribute('aria-current');
    });
    const chk = itemEl.querySelector('.switcher-upsell input');
    if (chk) chk.checked = true;
    return true;
  }
  async fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    if (!r.ok) return null;
    return r.json();
  }
  isTruthy(v) {
    if (v === true) return true;
    if (typeof v === 'string') {
      const s = v.toLowerCase();
      return s === 'true' || s === '1' || s === 'yes';
    }
    return false;
  }
  async enforceGiftRules() {
    const cart = await this.fetchCart();
    if (!cart) return;
    const paidVariants = new Set(
      cart.items
        .filter(i => !this.isTruthy(i.properties && i.properties['Free gift']))
        .map(i => String(i.variant_id))
    );
    const orphanGifts = cart.items.filter(i => {
      const props = i.properties || {};
      if (!this.isTruthy(props['Free gift'])) return false;
      const trigger = String(props['Gift trigger'] || '');
      if (!trigger) return paidVariants.size === 0;
      return !paidVariants.has(trigger);
    });
    for (const g of orphanGifts) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: g.key, quantity: 0 })
      });
    }
  }
  onKeydown(e) {
    if (e.key === 'Escape') this.close();
  }
  initSlider() {
    this.swiper = new Swiper('.sidecart__product-swiper', {
      slidesPerView: 1.3,
      spaceBetween: 6,
      loop: false,
      breakpoints: {
        998: {
          slidesPerView: 1.6,
        },
      },
      pagination: { el: '.sidecart__product-slider-pagination', clickable: true }
    });

  }
}
customElements.define('side-cart', SideCartDrawer);
